import { render, staticRenderFns } from "./CreatePlanPrevention.vue?vue&type=template&id=54aabecc&"
import script from "./CreatePlanPrevention.vue?vue&type=script&lang=ts&"
export * from "./CreatePlanPrevention.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports